import { useSelector } from "react-redux";
import { DtoResponseSelectStockPersonal } from "../../../Logistica/DetalleStockPersonalTotal/Domain/DtoResponseSelectStockPersonal";
import { useFindStockPersonalEquiposQuery } from "../../../shared/Infraestructure/SliceLogistica";
import './GridDetalleStockPersonal.scss';
import { RootState } from "../../../shared/Infraestructure/AdapterStore";
import { ViewLoading } from "../../../shared/Components/ViewLoading";
import { ViewError } from "../../../shared/Components/ViewError";

interface IStockPersonalEquipos {
    item: DtoResponseSelectStockPersonal
}

export function StockPersonalEquipos(props: IStockPersonalEquipos) {
    const { item } = props

    const { user } = useSelector((state: RootState) => state.auth)
    const { data, isLoading, isError, error } = useFindStockPersonalEquiposQuery({
        pais: user.Pais.Codigo,
        delegacion: user.Delegacion.Codigo,
        pipeline: [
            {
                $match: {
                    CodigoLlave: item.CodigoLlave,
                    CodigoBusqueda: item.CodigoBusqueda,
                    Identificacion: user.Identificacion,
                }
            },
            {
                $addFields: {
                    Equipos: {
                        $filter: {
                            input: '$Equipos',
                            as: 'equipo',
                            cond: { $eq: ['$$equipo.Estado.ID_Estado', 2] }
                        }
                    }
                }
            }
        ]
    })

    if (isLoading) return <ViewLoading />
    if (isError) return <ViewError error={error} />

    return (
        <table className="table table-sm">
            <thead>
                <tr>
                    <th>Serie</th>
                    <th>Marca</th>
                    <th>Modelo</th>
                    <th style={{ textAlign: 'center' }}>Días</th>
                    <th>Fecha</th>
                    <th>Estado</th>
                </tr>
            </thead>
            <tbody>
                {
                    data?.Equipos.map((item, index) => {
                        const hoy = new Date()
                        const fecha = new Date(item.Validado.Fecha)
                        const diferencia = hoy.getTime() - fecha.getTime()
                        const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24))

                        let color = ''

                        if (dias <= 5) {
                            color = '#90EE90' // verde claro
                        } else if (dias <= 20) {
                            color = '#FFD580' // naranja claro
                        } else {
                            color = '#FF7F7F' // rojo claro
                        }
                        return (
                            <tr key={index}>
                                <td>{item.Serie}</td>
                                <td>{item.Marca}</td>
                                <td>{item.Modelo}</td>
                                <td style={{ textAlign: 'center' }}>{dias}</td>
                                <td
                                    style={{ backgroundColor: color }}
                                >
                                    {fecha.toLocaleDateString('es-PE', { year: 'numeric', month: '2-digit', day: '2-digit' })}
                                </td>
                                <td>{item.Estado.Nombre}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
    )
}
